(function buttonScroll() {
    var hideButton = document.querySelector('[data-hide-button]');
    var productSection = document.querySelector('.product-section');
    window.addEventListener('scroll', function () {
        if (window.scrollY + window.innerHeight >= (productSection === null || productSection === void 0 ? void 0 : productSection.offsetHeight) + (productSection === null || productSection === void 0 ? void 0 : productSection.offsetTop)) {
            // @ts-ignore
            hideButton === null || hideButton === void 0 ? void 0 : hideButton.style.display = 'none';
        }
        else {
            // @ts-ignore
            hideButton === null || hideButton === void 0 ? void 0 : hideButton.style.display = '';
        }
    });
})();
